import { Box, IconButton, Tooltip } from '@mui/material';
import { Refresh, Save } from '@mui/icons-material';
import {
  CustomButton,
  DrawerFormActions,
  DrawerFormActionSummary,
} from '../../../common/components';
import { CONSOLIDATED_SUPPLY_TEXTS as TEXTS } from '../constants/consolidatedSupplyTexts';

/** Mantiene disponibles el resultado previsto y las acciones finales de la compra. */
const ConsolidatedSupplyFooter = ({
  created,
  documentCount,
  onClose,
  onView,
  onSave,
  onRefresh,
  onReview,
  isSaving,
  canSave,
  isLoading,
  activeSection,
  saveHint,
}) => (
  <DrawerFormActions
    summary={
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <DrawerFormActionSummary
          label={TEXTS.summary}
          value={
            isLoading
              ? TEXTS.loading
              : created.length
                ? TEXTS.success(created.length)
                : TEXTS.documents(documentCount)
          }
        />
        {!created.length && (
          <Tooltip title={TEXTS.refreshHint}>
            <span>
              <IconButton
                color="primary"
                onClick={onRefresh}
                disabled={isSaving || isLoading}
                aria-label={TEXTS.retry}
              >
                <Refresh fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
        )}
      </Box>
    }
  >
    <CustomButton variant="outlined" onClick={onClose} disabled={isSaving}>
      {created.length ? TEXTS.close : TEXTS.cancel}
    </CustomButton>
    {created.length ? (
      <CustomButton variant="base" onClick={onView}>
        {TEXTS.view}
      </CustomButton>
    ) : activeSection === 'summary' ? (
      <Tooltip title={saveHint}>
        <Box component="span" sx={{ display: 'inline-flex', width: { xs: '100%', sm: 'auto' } }}>
          <CustomButton
            variant="base"
            startIcon={<Save />}
            onClick={onSave}
            isLoading={isSaving}
            disabled={!canSave || isLoading}
          >
            {documentCount > 1 ? TEXTS.saveMultiple : TEXTS.save}
          </CustomButton>
        </Box>
      </Tooltip>
    ) : (
      <CustomButton variant="base" onClick={onReview} disabled={isSaving || isLoading}>
        {TEXTS.review}
      </CustomButton>
    )}
  </DrawerFormActions>
);

export default ConsolidatedSupplyFooter;
